import React from "react";
import css from './footer.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";
import FooterPromiseFloor from "./FooterPromiseFloor";
import FooterHelpFloor from "./FooterHelpFloor";
import FooterHelpFloor2 from "./FooterHelpFloor2";
import FooterRecordFloor from './FooterRecordFloor'

const Index = ({className}) => {
    return (
        <div className={classNames(className, css.root)}>
            {/* 正品承诺等 */}
            <FooterPromiseFloor className={css.promiseFloor}/>

            {/* 购物指南 配送方式等 帮助 */}
            <FooterHelpFloor className={css.helpFloor}/>

            {/* 首页 隐私政策 联系我们 等 */}
            <FooterHelpFloor2 className={css.helpFloor2}/>

            {/* 版权所有 持有人 备案 */}
            <FooterRecordFloor className={css.recordFloor}/>
        </div>
    )
}

export default observer(Index)